import { FiEdit } from "react-icons/all";
import { Tooltip } from "@chakra-ui/react";

import { Icon } from "components/Icon";
import { IconButton, IconButtonProps } from "components/IconButton";

interface IProps extends Omit<IconButtonProps, "aria-label"> {
  appointmentId: string;
}

const EditAppointmentButton = ({ appointmentId, ...props }: IProps) => {
  const editMessage = "Zmiana terminu";

  return (
    <Tooltip label={editMessage} aria-label={editMessage}>
      <IconButton
        id={`edit-appointment-${appointmentId}-icon-btn`}
        background="transparent"
        icon={<Icon w={5} h={5} color="black.900" icon={FiEdit} />}
        aria-label={editMessage}
        {...props}
      />
    </Tooltip>
  );
};

export { EditAppointmentButton };
